<!--

首页搜索栏，含商家Logo

使用说明：

<Searchbar
 :logo="'图片路径'"
 />

-->
<template>
  <div class="wrap">
    <Icon class="logo" :img="logo" size="cover" />

    <div class="search-bar">
      <form action="#" @submit="onSearch">
        <input type="search" @keyup.enter="onSearch" v-model="searchContent" />
        <i class="icon icon-search"></i>
        <span>搜索</span>
      </form>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: ["logo"],
  data() {
    return {
      searchContent: "",
      i: "http://res.uuudian.com/hk_data/64e7df00-79b7-4b72-af7e-6912fad19f4b"
    };
  },
  methods: {
    onSearch(e) {
      e.preventDefault();

      if (this.searchContent == "LOG") {
        //加载日志
        this.$showLoading("读取日志");
        var format = text => {
          return text.replace(/\n/g, "<br/><br/>");
        };
        $.get(process.env.logUrl + "?v=" + new Date().getTime(), r => {
          this.$hideLoading();

          this.$agreement("开发日志", format(r));

          this.searchContent = "";
        });

        return;
      }

      //默认进入搜索
      this.$routerPush(this, "/pages/products/List?q=" + this.searchContent);
    }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4.933vw 0 2.666vw 0;
}

.logo {
  width: 9vw;
  height: 9vw;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  margin-right: 1vw;
}

.search-bar {
  z-index: 1;
  height: 9vw;
  width: 79vw;
  border-radius: 4.5vw;
  background: white;
  position: relative;
  input {
    display: inline-block;
    width: 100%;
    height: 8vw;
    margin-top: 0.5vw;
    background: transparent;
    padding: 0 2vw;

    &:focus {
      & ~ .icon {
        display: none;
      }
      & ~ span {
        display: none;
      }
    }
  }

  .icon {
    position: absolute;
    // top: 7.2vw;
    top: 50%;
    left: 3vw;
    z-index: 2;
    width: 3.7vw;
    height: 3.7vw;
    // margin-left: -5.5vw;
    transform: translateY(-50%);
  }

  span {
    position: absolute;
    // top: 6.8vw;
    top: 50%;
    left: 8vw;
    z-index: 2;
    color: @themeColor;
    // width: 8vw;
    font-size: 3.7vw;
    text-align: left;
    transform: translateY(-50%);
  }
}
</style>





// WEBPACK FOOTER //
// src/components/homepage/Searchbar.vue